import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * ToggledSectionChildItem
 */
export default class ToggledSectionChildItem extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'ToggledSectionChildItem',
    options: {
      delay: {
        type: Number,
        default: 0,
      },
      add: {
        type: String,
        default: '',
      },
      remove: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * show
   */
  show() {
    setTimeout(() => {
      addClass(this.$el, this.$options.add);
      removeClass(this.$el, this.$options.remove);
    }, this.$options.delay);
  }

  /**
   * hide
   */
  hide() {
    removeClass(this.$el, this.$options.add);
    addClass(this.$el, this.$options.remove);
  }
}
